import styled from 'styled-components'

export const DescriptionWrapper = styled.div`
  margin-bottom: 16px;
  line-height: 150%;
`

export const VideoWrapper = styled.div`
  margin-bottom: 16px;
`
